import {
  isValidDate,
  transformDateToString,
  transformStringToDate,
} from '@mortgage-pos/utils'
import React, { FC } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'

export type DateInputProps = {
  value: string
  name: string
  subTitle: string
  setValue: (value: any) => void
}

const DateInput: FC<DateInputProps> = ({ subTitle, value, setValue, name }) => {
  const replacedValue = transformStringToDate(value)

  return (
    <DatePicker
      className="date-picker"
      label={subTitle}
      views={['year', 'month', 'day']}
      format="MM/dd/yyyy"
      value={replacedValue}
      data-testid={`date-input-${name}`}
      onChange={(date: Date) => {
        if (!isValidDate(date)) {
          return
        }

        setValue(transformDateToString(date))
      }}
    />
  )
}

export default DateInput
